export const MEMBERSHIP_CHANGE_PLAN = 'MEMBERSHIP_CHANGE_PLAN';
export const MEMBERSHIP_CHANGE_PLAN_DONE = 'MEMBERSHIP_CHANGE_PLAN_DONE';
export const MEMBERSHIP_CHANGE_PLAN_ERROR = 'MEMBERSHIP_CHANGE_PLAN_ERROR';
export const MEMBERSHIP_CHANGE_PLAN_RESET = 'MEMBERSHIP_CHANGE_PLAN_RESET';
//# sourceMappingURL=actionTypes.js.map